<ui-svg-icon
    [icon]="icon"
    [style.fontSize]="iconSize + 'px'">
</ui-svg-icon>
